import * as classes from './index.scss';

//document.getElementById('domain').innerHTML = 'wholivesnearyou.com';
document.getElementById('domain').innerHTML = window.location.hostname;
document.getElementById('domain_name').value = window.location.hostname;